import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useZoneOptionsQuery } from "hooks/useZoneQuery";
import { holdPalletOptions } from "layouts/views/common/options";
import { useState } from "react";
import { SelectField } from "ui-components/Form";

import { Text, DatePickerField } from "ui-components/Form";

function StockTransferDetailInfo({ formRender, control, errors, warehouseCode }) {
  const [zoneIDOptions, setZoneIDOptions] = useState([]);

  useZoneOptionsQuery({
    whCode: warehouseCode,
    zoneType: "Storage/Quarantine/Return/Scrap",
    onSuccess: (data) => {
      let result = data.data.data;
      setZoneIDOptions(result);
    }
  });

  function renderFn(property, index, length) {
    const { xs, disabled, edit, ...data } = property;
    //custom xs
    const xs2 = xs ? xs : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
    };

    let renderField;
    if (data.type === "text" || data.type === "number") {
      renderField = <Text field={fieldProps} />;
    } else if (data.type === "date") {
      renderField = <DatePickerField field={fieldProps} />;
    } else if (data.type === "select") {
      renderField = (
        <SelectField
          field={fieldProps}
          options={
            (data.name === "holdPallet" && holdPalletOptions)||
            (data.name === "zoneID" && zoneIDOptions)
          }
          control={control}
          errors={errors}
        />
      );
    }
    return (
      <Grid key={index} item xs={xs2}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <MDTypography mt={1.625} mb={2} color="info" variant="h5">
            Filter
          </MDTypography>
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default StockTransferDetailInfo;
